import { Alert, Divider, Row, Skeleton } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import DetailPageHeader from '../components/detail-page-header';
import LanguageButtons from '../components/language-buttons';
import PropertyCategories from '../components/property/categories';
import PropertyName from '../components/property/name';
import PropertyType from '../components/property/type';
import PropertyUnit from '../components/property/unit';
import PropertyValue from '../components/property/value';
import WarehouseProperty from '../components/property/warehouse-property';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import { categoriesLoadAll } from '../reducers/categories/reducer';
import { propertyLoad } from '../reducers/property/reducer';
import { SPACING } from '../theme/tokens';

function PropertyContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const propertyProperty = useSelector((s: RootState) => s.Property.property);
  const propertyInProcess = useSelector((s: RootState) => s.Property.inProcess);

  const { propertyCode } = useParams();

  useEffect((): void => {
    if (propertyCode) {
      dispatch(propertyLoad(propertyCode));
      dispatch(categoriesLoadAll());
    }
  }, [dispatch, propertyCode]);

  if (propertyProperty === undefined) {
    return <Skeleton active />;
  }

  if (propertyProperty === null) {
    return <Alert title="Property not found" type="error" showIcon />;
  }

  return (
    <>
      <DetailPageHeader
        title={propertyCode ?? ''}
        onReload={(): void => {
          if (!propertyCode) {
            return;
          }

          dispatch(propertyLoad(propertyCode));
        }}
        isReloadDisabled={propertyInProcess}
      />

      <LanguageButtons />

      <Divider />

      <Row gutter={SPACING.lg}>
        <PropertyName />

        <PropertyUnit />

        <PropertyType />
      </Row>

      <Divider />

      <Row gutter={SPACING.lg}>
        <PropertyCategories />
      </Row>

      <Divider />

      <Row gutter={SPACING.lg}>
        <WarehouseProperty />

        <PropertyValue />
      </Row>
    </>
  );
}

export default PropertyContainer;
